module.exports = __webpack_public_path__ + "img/DP.f29f6e97.svg";